export default __webpack_public_path__ + "static/media/bdc_Img.f46060f4.png";